import { render, staticRenderFns } from "./LegalText.vue?vue&type=template&id=18587975&"
import script from "./LegalText.vue?vue&type=script&lang=js&"
export * from "./LegalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports